<div class="fs-2 with-close" mat-dialog-title>
    Confirmation
</div>
<div mat-dialog-content>
    <h2 class="mt-2 mb-4">Un petit instant, svp.</h2>
    <p>Vous avez choisi un forfait gratuit qui ne vous donne pas accès à toutes les fonctionnalité LyBox</p>
    <div class="bg">
        <h2 class="mb-4">Avec le forfait gratuit :</h2>
        <ul class="mb-0">
            <li><img class="me-1" src="assets/not.png" /> Perte de l’accès aux annonces immobilières.</li>
            <li><img class="me-1" src="assets/not.png" /> Perte de l’accès à vos simulations.</li>
            <li><img class="me-1" src="assets/not.png" /> Passer 7 fois plus de temps à chercher des biens.</li>
            <li><img class="me-1" src="assets/not.png" /> Perte de toutes vos réductions.</li>
            <li><img class="me-1" src="assets/not.png" /> Passage à des fonctionnalités limitées de LyBox.</li>
        </ul>
    </div>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Confirmer
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        Changer de forfait
    </button>
</div>
